import { render, staticRenderFns } from "./ToolboxTalkMultipleSignatureRequest.vue?vue&type=template&id=522e59d4&"
import script from "./ToolboxTalkMultipleSignatureRequest.vue?vue&type=script&lang=js&"
export * from "./ToolboxTalkMultipleSignatureRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports